/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-21 09:46:44
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-11-02 11:19:37
 */

const mumeListData = [
  {
    moduleName: "首页",
    icon: "",
    menuIndex: "1",
    url: "/home"
  },
  // {
  //   moduleName: "test",
  //   icon: "",
  //   menuIndex: "2",
  //   url: "/test",
  //   children: [
  //     {
  //       moduleName: "test",
  //       icon: "",
  //       menuIndex: "2-1",
  //       url: "/test"
  //     },
  //     {
  //       moduleName: "22222",
  //       icon: "",
  //       menuIndex: "2-2",
  //       url: "/test"
  //     }
  //   ]
  // },
  {
    moduleName: "收入结算",
    icon: "",
    menuIndex: "2",
    url: "/revenue-settlement",
    children: [
      {
        moduleName: "分成结算",
        icon: "",
        menuIndex: "2-1",
        url: "/revenue-settlement/share-settlement"
      },
      {
        moduleName: "提现单",
        icon: "",
        menuIndex: "2-2",
        url: "/revenue-settlement/withdraw-form"
      }
    ]
  },
  {
    moduleName: "运营管理",
    icon: "",
    menuIndex: "3",
    url: "/oper-manage",
    children: [
      {
        moduleName: "运营数据",
        icon: "",
        menuIndex: "3-1",
        url: "/oper-manage/operation-data"
      },
      {
        moduleName: "充电订单",
        icon: "",
        menuIndex: "3-2",
        url: "/oper-manage/charge-order-list"
      }
    ]
  },
  {
    moduleName: "站点管理",
    icon: "",
    menuIndex: "4",
    url: "/pile-manage",
    children: [
      {
        moduleName: "站点信息",
        icon: "",
        menuIndex: "4-1",
        url: "/pile-manage/pile-info"
      },
      {
        moduleName: "充电桩信息",
        icon: "",
        menuIndex: "4-2",
        url: "/pile-manage/pile-list"
      }
    ]
  },
  {
    moduleName: "运营监控",
    icon: "",
    menuIndex: "6",
    url: "/operation-analysis",
    children: [
      {
        moduleName: "站点监控",
        icon: "",
        menuIndex: "6-1",
        url: "/operation-analysis/site-monitor"
      },
      {
        moduleName: "告警管理",
        icon: "",
        menuIndex: "6-2",
        url: "/operation-analysis/alarm-list"
      },
      {
        moduleName: "告警管理",
        icon: "",
        menuIndex: "6-2",
        url: "/operation-analysis/alarm-event"
      }
      //
    ]
  },
  {
    moduleName: "会员管理",
    icon: "",
    menuIndex: "7",
    url: "/member-management",
    children: [
      {
        moduleName: "非实名卡管理",
        icon: "",
        menuIndex: "7-1",
        url: "/member-management/non-real-name-card-management"
      }
    ]
  },
  {
    moduleName: "商户信息",
    icon: "",
    menuIndex: "8",
    url: "/merchant-management",
    children: [
      {
        moduleName: "商户信息",
        icon: "",
        menuIndex: "8-1",
        url: "/merchant-management/merchant-management"
      }
    ]
  }
];
export default mumeListData;
